// extracted by mini-css-extract-plugin
export var boldText = "_79-4";
export var checkboxContainer = "_79-6";
export var closeIcon = "_79-i";
export var container = "_79-0";
export var drawer = "_79-8";
export var drawerContent = "_79-9";
export var extraSmallText = "_79-5";
export var fulfillmentGroupTable = "_79-e";
export var largeText = "_79-3";
export var loadingSpinnerContainer = "_79-j";
export var mediumText = "_79-2";
export var narrow = "_79-f";
export var notificationLink = "_79-l";
export var packageCheckIconContainer = "_79-7";
export var slideoutHeaderActions = "_79-g";
export var slideoutHeaderActionsShifted = "_79-h";
export var slideoutHeaderContainer = "_79-a";
export var slideoutModal = "_79-c";
export var stickyHeaderWrapper = "_79-b";
export var table = "_79-k";
export var tableContainer = "_79-d";
export var tertiaryText = "_79-1";